/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home';
import Login from '@/views/Login';
import SignUpMFA from '@/views/SignUpMFA';
import ResetPwd from '@/views/ResetPwd';
import Lounge from '@/views/Lounge';
import LoungeDetails from '@/views/ProductionDetails/LoungeDetails';
import LoungePrebook from '@/views/LoungePrebook';
import PrebookSuccess from '@/views/PrebookSuccess';
import UserInfoDialogModalBussinessComponent from '@/components/UserInfoDialogModalBussinessComponent';
import Membership from '@/views/Membership';
import Member from '@/views/Membership/component/Member';
import Favourites from '@/views/Membership/component/Favourites';
import PlacesIndex from '@/views/Membership/component/Places/index.vue';
import PlacesDetails from '@/views/Membership/component/Places/details.vue';
import Email from '@/views/Membership/component/Email';
import ChangePassword from '@/views/Membership/component/Security/ChangePassword';
import SecurityHistory from '@/views/Membership/component/Security/history';
import MFA from '@/views/Membership/component/MFA';
import Contact from '@/views/Membership/component/Contact';
import SwitchMembership from '@/views/SwitchMembership';
import RemoveMembership from '@/views/SwitchMembership/RemoveMembership';
import MyTrips from '@/views/Membership/component/MyTrips';
import TripsDetail from '@/views/Membership/component/TripsDetail';
import Notify from '@/views/Membership/component/Notify';
import DeleteAccount from '@/views/Membership/component/DeleteAccount';
import AddNewMembership from '@/views/AddNewMembership';
import UpdateVisaCard from '@/views/UpdateVisaCard';
import DiningDetails from '@/views/ProductionDetails/DiningDetails';
import RetailDetails from '@/views/ProductionDetails/RetailDetails';
import RetailDetailsFilter from '@/views/ProductionDetails/RetailDetails/Filter';
import BenefitDetails from '@/views/ProductionDetails/BenefitDetails';
import OfferDetails from '@/views/ProductionDetails/OfferDetails';
import BenefitsOffersDetails from '@/views/BenefitsOffersDetails';
import Docs from '@/views/Docs';
import Faqs from '@/views/Faqs';
import PrebookBanner from '@/views/PrebookBanner';
import EnquiryForm from '@/views/EnquiryForm';
import NotFound from '@/views/NotFound';
import i18n from '@/i18n';
import { decryptAES, getBrowserLanguageName, getI18nLanguageName } from '@/utils';
import msgModal from '@/components/BaseUi/MessageModal/src';
import store from '@/store';
import PrivacySettings from '@/views/Membership/component/PrivacySettings';
import UpdateCardSuccess from '@/views/UpdateCardSuccess';
import AddCardSuccess from '@/views/AddCardSuccess';

const routes = [
  {
    path: '/',
    exact: true,
    redirect: '/home',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      title: 'Home',
    },
  },
  {
    path: '/sign-up',
    name: 'SignUp',
    component: SignUpMFA,
    meta: {
      title: 'Sign Up',
    },
  },
  {
    path: '/reset-pwd',
    name: 'ResetPwd',
    component: ResetPwd,
    meta: {
      title: 'Reset Password',
    },
  },
  {
    path: '/lounges',
    name: 'Lounges',
    component: Lounge,
    meta: {
      title: 'Lounges',
    },
  },
  {
    path: '/lounge/details',
    name: 'LoungeDetails',
    component: LoungeDetails,
    meta: {
      title: 'Lounge Details',
    },
  },
  {
    path: '/lounge/prebook',
    name: 'LoungePrebook',
    component: LoungePrebook,
    meta: {
      title: 'Lounge Prebook',
    },
  },
  {
    path: '/prebooksuccess',
    name: 'PrebookSuccess',
    component: PrebookSuccess,
    meta: {
      title: 'Prebook Success',
    },
  },
  {
    path: '/benefits',
    name: 'Benefits',
    component: Lounge,
    meta: {
      title: 'Benefits',
    },
  },
  {
    path: '/dining',
    name: 'Dining',
    component: Lounge,
    meta: {
      title: 'Dining Offers',
    },
  },
  {
    path: '/retail',
    name: 'Retail',
    component: Lounge,
    meta: {
      title: 'Retail Offers',
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: UserInfoDialogModalBussinessComponent,
    meta: {
      title: 'Profile',
    },
  },
  {
    path: '/account',
    meta: {
      requireAuth: true,
    },
    component: Membership,
    children: [
      {
        path: '',
        meta: {
          requireAuth: true,
        },
        redirect: '/account/membership',
      },
      {
        path: 'membership',
        name: 'Membership',
        meta: {
          requireAuth: true,
          title: 'Membership',
        },
        component: Member,
      },
      {
        path: 'favourites',
        name: 'Favourites',
        meta: {
          requireAuth: true,
          title: 'Favourites',
        },
        component: Favourites,
      },
      {
        path: 'places',
        name: 'Places',
        meta: {
          requireAuth: true,
          title: 'Visited Places',
        },
        component: PlacesIndex,
      },
      {
        path: 'places/visited',
        name: 'VisitedPlaces',
        meta: {
          requireAuth: true,
          title: 'Visited Places',
        },
        component: PlacesDetails,
      },
      {
        path: 'email',
        name: 'Email',
        meta: {
          requireAuth: true,
          title: 'Email Language',
        },
        component: Email,
      },
      {
        path: 'changeKey',
        name: 'ChangeKey',
        meta: {
          requireAuth: true,
          title: 'Change Password',
        },
        component: ChangePassword,
      },
      {
        path: 'history',
        name: 'History',
        meta: {
          requireAuth: true,
          title: 'Login History',
        },
        component: SecurityHistory,
      },
      {
        path: 'mfa',
        name: 'MFA',
        meta: {
          requireAuth: true,
          title: 'MFA',
        },
        component: MFA,
      },
      {
        path: 'contact',
        name: 'Contact',
        meta: {
          requireAuth: true,
          title: 'Get in Touch',
        },
        component: Contact,
      },
      {
        path: 'switchmembership',
        name: 'SwitchMembership',
        meta: {
          requireAuth: true,
          title: 'Switch Membership',
        },
        component: SwitchMembership,
      },
      {
        path: 'removemembership',
        name: 'RemoveMembership',
        meta: {
          requireAuth: true,
          title: 'Remove Membership',
        },
        component: RemoveMembership,
      },
      {
        path: 'mytrips',
        name: 'MyTrips',
        meta: {
          requireAuth: true,
          title: 'My Trips',
        },
        component: MyTrips,
      },
      {
        path: 'tripsDetail',
        name: 'TripsDetail',
        meta: {
          requireAuth: true,
          title: 'Trip Details',
        },
        component: TripsDetail,
      },
      {
        path: 'notify',
        name: 'Notify',
        meta: {
          requireAuth: true,
          title: 'Notifications',
        },
        component: Notify,
      },
      {
        path: 'deleteaccount',
        name: 'DeleteAccount',
        meta: {
          requireAuth: true,
          title: 'Delete Account',
        },
        component: DeleteAccount,
      },
      {
        path: 'privacysettings',
        name: 'PrivacySettings',
        meta: {
          requireAuth: true,
        },
        component: PrivacySettings,
      },
    ],
  },
  {
    path: '/addnewmembership',
    name: 'AddNewMembership',
    meta: {
      requireAuth: true,
      title: 'Add New Membership',
    },
    component: AddNewMembership,
  },
  {
    path: '/updatevisacard',
    name: 'UpdateVisaCard',
    meta: {
      requireAuth: true,
      title: 'Update Visa Card',
    },
    component: UpdateVisaCard,
  },
  {
    path: '/dining/details',
    name: 'DiningDetails',
    component: DiningDetails,
    meta: {
      title: 'Dining Details',
    },
  },
  {
    path: '/retail/details',
    name: 'RetailDetails',
    component: RetailDetails,
    meta: {
      title: 'Retail Details',
    },
  },
  {
    path: '/retail/details/filter/:airportCode/:codes',
    name: 'RetailDetailsFilter',
    component: RetailDetailsFilter,
    meta: {
      title: 'Retail Details',
    },
  },
  {
    path: '/benefit/details',
    name: 'BenefitDetails',
    meta: {
      requireAuth: true,
      title: 'Visa Benefits Details',
    },
    component: BenefitDetails,
  },
  {
    path: '/offer/details',
    name: 'OfferDetails',
    meta: {
      requireAuth: true,
      title: 'Visa Offer Details',
    },
    component: OfferDetails,
  },
  {
    path: '/visabenefits',
    name: 'Visabenefits',
    meta: {
      requireAuth: true,
      title: 'Visa Benefits',
    },
    component: BenefitsOffersDetails,
  },
  {
    path: '/visaoffers',
    name: 'Visaoffers',
    meta: {
      requireAuth: true,
      title: 'Visa Offers',
    },
    component: BenefitsOffersDetails,
  },
  {
    path: '/:doc(terms|termsofuse|privacypolicy|about|programterms|termsofservice)',
    name: 'Docs',
    component: Docs,
    meta: {
      title: 'Docs',
    },
  },
  {
    path: '/faqs',
    name: 'Faqs',
    component: Faqs,
    meta: {
      title: 'FAQs',
    },
  },
  {
    path: '/prebookbanner',
    name: 'PrebookBanner',
    component: PrebookBanner,
    meta: {
      title: 'Prebook Banner',
    },
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: EnquiryForm,
    meta: {
      title: 'Feedback',
    },
  },
  {
    path: '/updateCardSuccess',
    name: 'UpdateCardSuccess',
    component: UpdateCardSuccess,
    meta: {
      title: 'Update Card Success',
    },
  },
  {
    path: '/addCardSuccess',
    name: 'AddCardSuccess',
    component: AddCardSuccess,
    meta: {
      title: 'Add Card Success',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return {
      left: 0,
      top: 0,
    };
  },
});

const nextFn = (to, from, next, lang) => {
  const to_query = JSON.parse(JSON.stringify(to.query));
  to_query.lang = lang;
  next({
    path: to.path,
    query: to_query,
    replace: to.name === from.name ? true : false,
  });
};

router.beforeEach((to, from, next) => {
  // 判断是否需要登录
  const token = sessionStorage.getItem('token') && decryptAES(sessionStorage.getItem('token'));
  if (!token && to.meta.requireAuth) {
    sessionStorage.setItem('afterLoginRouter', to.fullPath);
    router.push('/login');
  } else if (token) {
    // next();
    // 已登录状态需要倒计时，写在路由拦截器这里，可以保证刷新页面后计时器依然生效
    let timeoutID;
    const startTimer = () => {
      timeoutID = setTimeout(() => {
        store.dispatch('loginModule/logout').then(res => {
          clearTimeout(timeoutID);
          msgModal.show({
            image: false,
            desc: i18n.global.t('login-timeout-15min'),
            confirmBtn: 'ok',
            justHide: true,
            closeIcon: true,
            i18nNeed: false,
            // callback: () => {
            //   clearTimeout(timeoutID);
            // },
          });
        });
      }, 900000); // 900000 = 15 minutes
    };
    const resetTimer = () => {
      clearTimeout(timeoutID);
      startTimer();
    };
    // 监听用户活动事件
    // 鼠标移动
    document.addEventListener('mousemove', resetTimer); // 用户正在浏览页面
    // 鼠标单击
    document.addEventListener('click', resetTimer); // 用户正在与页面交互
    // 按键按下
    document.addEventListener('keypress', resetTimer); // 用户正在输入或操作页面元素
    // 滚动页面
    document.addEventListener('scroll', resetTimer); // 用户正在滚动页面
    // 触摸屏幕
    document.addEventListener('touchstart', resetTimer); // 用户正在触摸屏幕上的元素
    // 缩放屏幕
    document.addEventListener('gesturestart', resetTimer); // 用户正在缩放屏幕
    // 改变窗口大小
    window.addEventListener('resize', resetTimer); // 用户正在调整窗口大小
    // 启动计时器
    startTimer();
  }

  // 更新页面标题
  const title = to.meta.title;
  if (title) {
    document.title = title;
  } else {
    // 设置默认标题
    document.title = 'Visa Airport Companion';
  }

  const langMap = {
    en: 'en_US',
    fr: 'fr_CA',
  };
  // a.用户主动输入带?lang=xx的情况
  const {
    query: { lang: queryLang },
  } = to;
  const storageLang = localStorage.getItem('lang');
  // getI18nLanguageName -> en/fr
  if (queryLang && Object.keys(langMap).find(_ => _ === queryLang)) {
    i18n.global.locale = langMap[queryLang];
    localStorage.setItem('lang', i18n.global.locale);
    // 设置 html 的 lang 属性
    document.documentElement.setAttribute('lang', queryLang);
    next();
  } else {
    // b.用户没有输入?lang=xx的情况
    if (storageLang) {
      // b(1) 用户没有清除本地已有的语言缓存访问网站
      const lang = getI18nLanguageName(storageLang);
      nextFn(to, from, next, lang);
    } else {
      // b(2) 用户本地没有语言缓存时访问网站，读取浏览器语种，默认是英语
      const browserLanguage = navigator.language; // en-GB-> enGB
      if (
        Object.values(langMap)
          .map(_ => _.replace('_', ''))
          .find(_ => _ === browserLanguage.replace('-', ''))
      ) {
        const lang = getBrowserLanguageName(browserLanguage);
        nextFn(to, from, next, lang);
      } else {
        nextFn(to, from, next, 'en');
      }
    }
  }
});

export default router;
